import { BaseEntity } from '../base-entity';

export class FormRs009Filter extends BaseEntity {
    // tslint:disable-next-line: variable-name
    cerar: string;
    // tslint:disable-next-line: variable-name
    safra: string;
    // tslint:disable-next-line: variable-name
    contrato_juridico: string;
    // tslint:disable-next-line: variable-name
    produto: string;
    // tslint:disable-next-line: variable-name
    numero_campo: string;
    // tslint:disable-next-line: variable-name
    site_recebimento: string;
    // tslint:disable-next-line: variable-name
    is_incomplete: boolean;
    // tslint:disable-next-line: variable-name
    resp_validacao: string;
}
